"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyList = exports.makeSymbol = exports.makeString = exports.makeBool = exports.makeNumber = void 0;
const makeNumber = (value, loc) => {
    return { type: 'number', value, loc };
};
exports.makeNumber = makeNumber;
const makeBool = (value, loc) => {
    return { type: 'boolean', value, loc };
};
exports.makeBool = makeBool;
const makeString = (value, loc) => {
    return { type: 'string', value, loc };
};
exports.makeString = makeString;
const makeSymbol = (value, isFromSource, loc) => {
    return { type: 'symbol', value, isFromSource, loc };
};
exports.makeSymbol = makeSymbol;
const makeEmptyList = () => {
    return { type: 'empty list' };
};
exports.makeEmptyList = makeEmptyList;
//# sourceMappingURL=sExpression.js.map